import {useFormik} from "formik";
import {Button, Input, Modal, Select} from "antd";
import React, {useEffect, useState} from "react";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {useApiUpdateAdminProfile} from "@/api/userAcademy";
import {useApiLocationCountry} from "@/api/location";
import TextArea from "antd/lib/input/TextArea";
import ProvinceCityCMP from "@/components/provinceCity";
import {useParams} from "react-router-dom";

export default function ChangeLocationModal({user, onSubmit, onClose, openModal}) {
    const [loading, setLoading] = useState(false);
    const [countryList, setCountryList] = useState([])
    const {data: country} = useApiLocationCountry()
    const [city, setCity] = useState()
    const [province, setProvince] = useState()

    const {mutate: updateProfile} = useApiUpdateAdminProfile();

    const params = useParams();

    useEffect(() => {
        if (country?.data) {
            setCountryList(country?.data)
        }
    }, [country])

    useEffect(() => {
        if (city) {
            formik.setFieldValue('city', city)
        }
    }, [city])

    useEffect(() => {
        if (province) {

            formik.setFieldValue('province', province)
        }
    }, [province])

    const formik = useFormik({
        initialValues: {
            country: user?.country,
            province: user?.province,
            city: user?.city,
            zipcode: user?.zipcode,
            shfrom: user?.shfrom,
            address: user?.address,

        },
        validate: (values) => {
            const errors = {};
            // if (!values.firstname) errors.firstname = "نام الزامی است";
            // if (!values.lastname) errors.lastname = "نام خانوادگی الزامی است";
            // if (!values.father) errors.father = "نام پدر الزامی است";
            // if (!values.birthdate) errors.birthdate = "تاریخ تولد الزامی است";
            // if (!values.marital) errors.marital = "وضعیت تاهل الزامی است";

            return errors;
        },
        onSubmit: (values) => {
            values.id = params.id;
            setLoading(true);
            updateProfile(values, {
                onSuccess: (res) => {
                    onSubmit(res);
                    ApiHandleSuccessMessage(res);
                    setLoading(false);
                },
                onError: (errors) => {
                    ApiHandleErrorMessage(errors);
                    setLoading(false);
                },
            });
        },
    });


    return (
        <Modal
            title={"اطلاعات محل سکونت خود را با دقت وارد کنید"}
            open={openModal}
            onCancel={() => {
                onClose?.();
            }}
            footer={[
                <Button onClick={() => onClose?.()}>لغو</Button>,
                <Button
                    type="primary"
                    loading={loading}
                    disabled={loading}
                    onClick={() => formik.submitForm()}
                >
                    ذخیره
                </Button>,
            ]}
        >
            <div className="flex flex-col gap-3">
                <FormField label="کشور" name="country">
                    <Select
                        className={'block'}
                        defaultValue={formik.values.country}
                        placeholder={'انتخاب کنید'}
                        id={'country'}
                        onChange={(e) => formik.setFieldValue('country', e)}
                        options={countryList?.map((value, i) => {
                            return {value: value.key, label: value.fa_name}
                        })}
                    />
                </FormField>

                {formik.values.country === 'IR' && (<div>
                    <ProvinceCityCMP setCity={setCity}
                                     setProvince={setProvince}
                                     currentCity={formik.values.city}
                                     currentProvince={formik.values.province}/>
                </div>)}


                <FormField label="آدرس" name="address">
                    <Input.TextArea
                        name="address"
                        value={formik.values.address}
                        onChange={(e) => formik.setFieldValue('address', e.target.value)}
                    />
                    {formik.errors.address && <ErrorMessageWidget message={formik.errors.address}/>}
                </FormField>
                <FormField label="کدپستی" name="zipcode">
                    <Input
                        style={{direction: 'ltr'}}
                        name="zipcode"
                        value={formik.values.zipcode}
                        onChange={(e) => formik.setFieldValue('zipcode', e.target.value)}
                    />
                </FormField>


            </div>
        </Modal>
    );
}

export const ErrorMessageWidget = ({message}) => (
    <span className={`text-xs text-red-500`}>{message}</span>
);

export const FormField = ({label, name, children}) => (
    <div className="flex flex-col gap-1">
        <label htmlFor={name} className="font-medium">
            {label}
        </label>
        {children}
    </div>
);
